import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { EdaResults } from '../../types';

interface MissingValuesChartProps {
  edaResults: EdaResults | null;
}

// Helper function to prepare data for the chart
const prepareChartData = (missingValues: Record<string, number> | undefined) => {
  if (!missingValues) return [];
  return Object.entries(missingValues)
    .map(([name, count]) => ({ name, 'Fehlende Werte': count }))
    .filter(item => item['Fehlende Werte'] > 0); // Only show features with missing values
};

export const MissingValuesChart: React.FC<MissingValuesChartProps> = ({ edaResults }) => {
  if (!edaResults) {
    return <p>Keine EDA Daten vorhanden.</p>;
  }

  const chartData = prepareChartData(edaResults.features_stats.missing_values_total);

  if (chartData.length === 0) {
      return (
          <div className="chart-container card">
              <h3>Fehlende Werte pro Feature</h3>
              <p>Keine fehlenden Werte in den Features gefunden.</p>
          </div>
      );
  }

  return (
    <div className="chart-container card">
       <h3>Fehlende Werte pro Feature</h3>
       <ResponsiveContainer width="100%" height={300}>
        <BarChart
          data={chartData}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis allowDecimals={false} label={{ value: 'Anzahl', angle: -90, position: 'insideLeft' }} />
          <Tooltip />
          <Legend />
          <Bar dataKey="Fehlende Werte" fill="#8884d8" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}; 